












import { computed, defineComponent, PropType } from "@vue/composition-api";
import { getQuestionaryInfoFields } from "@/lib/questionaryFieldsHelper";
import BaseButton from "@/components/BaseButton";

export default defineComponent({
  name: "SocialMediaAccountsView",
  components: { BaseButton },
  props: {
    questionaryInfo: { type: Object as PropType<Record<string, string>>, required: true },
  },
  setup(props) {
    const fields = computed(() =>
      getQuestionaryInfoFields()
        .filter(i => i.fieldMeta?.social || i.fieldMeta?.calendar)
        .filter(i => props.questionaryInfo[i.name])
        .map(i => `${i.fieldMeta?.site ?? ""}${props.questionaryInfo[i.name]}`)
    );
    return {
      fields,
    };
  },
});
